import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { auth, db } from "../../../../config/firebaseConfig";
import { useSelector } from "react-redux";
import EnrolledChildrenSection from "./EnrolledChildrenSection";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import { Button } from "../../../../components";

const AiLabClasses = () => {
  const navigate = useNavigate();
  const [activeEnrollments, setActiveEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userDetails: parentsDetails } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchEnrollments = async () => {
      const parentId = parentsDetails?.id || auth?.currentUser?.uid;
      if (!parentId) {
        setLoading(false);
        return;
      }

      if (parentsDetails?.accountType === "student") {
        const aiLab = parentsDetails?.enrolment?.["ai-lab"];
        if (aiLab && aiLab.paymentStatus === "verified") {
          setActiveEnrollments([{ id: parentId, uid: parentId, ...parentsDetails }]);
        } else {
          setActiveEnrollments([]);
        }
        setLoading(false);
        return;
      }

      // Parent user: Query children collection
      try {
        const q = query(
          collection(db, "students"),
          where("parentUid", "==", parentId)
        );
        const snap = await getDocs(q);
        const activeList = [];
        snap.docs.forEach(doc => {
          const childData = doc.data();
          const aiLab = childData.enrolment?.["ai-lab"];
          if (aiLab && aiLab.paymentStatus === "verified") {
            activeList.push({ id: doc.id, uid: doc.id, ...childData });
          }
        });
        setActiveEnrollments(activeList);
      } catch (err) {
        console.error("Error fetching AI Lab enrollments:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEnrollments();
  }, [parentsDetails]);

  if (loading) {
    return (
      <div className="w-full flex items-center justify-center p-12">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
          <p className="text-slate-500 font-bold">Loading classes...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full mx-auto max-w-5xl px-4 py-8 space-y-6">
      <button 
        onClick={() => navigate("/dashboard")}
        className="flex items-center gap-2 text-slate-500 hover:text-slate-800 font-bold text-sm transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> Go to Dashboard
      </button>

      {activeEnrollments.length > 0 ? (
        <EnrolledChildrenSection enrollments={activeEnrollments} />
      ) : (
        <div className="p-10 text-center bg-white border border-slate-200 rounded-2xl shadow-sm space-y-4">
          <p className="text-slate-600 font-semibold text-lg">You have no active AI Lab classes.</p>
          <Button 
            version="secondary"
            text="Book Free Demo"
            handleClick={() => navigate("/dashboard?type=book-robotics-lab-demo")}
          >
            <Sparkles className="w-4 h-4 ml-1 text-amber-500 animate-pulse" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default AiLabClasses;
